import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-enc-id-modal',
	templateUrl: './enc-id-modal.component.html',
	styleUrls: ['./enc-id-modal.component.scss'],
})
export class EncIdModalComponent {
	showButtons: false;
	title = '';
	modalContent =
		'We need additional information to complete your activation. Please contact member services at 800.362.8671 or MemberServices@ehe.health.';
	constructor(private dialogRef: MatDialogRef<EncIdModalComponent>) {}

	getAction(actionType: string): void {
		if (actionType === 'CLOSE') {
			this.dialogRef.close();
		}
	}
}
